<template>
  <div class="col-xs-12">


          <div class="input-daterange form-group row">
              <div class="input-date-time-picker" >

                  <div class="col-sm-12 col-md-6">
                      <div class="col-sm-12 col-md-12" align="left">
                          <div class="col-md-6 col-sm-12">
                              <label for="startDateTime">{{ labelStartDate[actualLanguage] }}</label>
                              <date-picker
                                  class="el-input__inner form-control"
                                  v-model="myStartDate"
                                  type="date"
                                  placeholder=""
                                  clear-icon=""
                                  format="yyyy-MM-dd"
                                  value-format="timestamp"
                              />
                          </div>
                          <div class="col-md-6 col-sm-12">
                              <label for="startDateTime">{{ labelStartTime[actualLanguage] }}</label>
                              <time-select
                                  v-model="startTime"
                                  placeholder=""
                                  clear-icon=""
                                  :picker-options="{
                                      start: '00:00',
                                      step: '01:00',
                                      end: '24:00'
                                  }"
                              />
                          </div>
                      </div>

                      <div class="col-md-12 col-sm-12" align="left">
                          <div class="col-md-6 col-sm-12">
                              <label for="startDateTime">{{ labelEndDate[actualLanguage] }}</label>
                              <date-picker
                                  class="el-input__inner form-control"
                                  v-model="myEndDate"
                                  type="date"
                                  placeholder=""
                                  clear-icon=""
                                  format="yyyy-MM-dd"
                                  value-format="timestamp"
                              />
                          </div>
                          <div class="col-md-6 col-sm-12">
                              <label for="startDateTime">{{ labelEndTime[actualLanguage] }}</label>
                              <time-select
                                  v-model="endTime"
                                  placeholder=""
                                  clear-icon=""
                                  :picker-options="{
                                      start: '00:00',
                                      step: '01:00',
                                      end: '24:00'
                                  }"
                              />
                          </div>
                      </div>
                  </div>

                  <div class="col-md-6 col-xs-12" align="center">
                    <div class="col-xs-12 push">
                      <div class="form-group">
                          <label class="col-xs-12">{{labelDataSamplingTitle[actualLanguage]}}</label>
                          <div class="col-xs-12">
                              <label class="radio-inline" for="example-inline-radio1">
                                  <input type="radio" value="Automatic" v-model="dataSamplingSelect"> {{labelDataSamplingAuto[actualLanguage]}}
                              </label>
                              <label class="radio-inline" for="example-inline-radio2">
                                  <input type="radio" value="5Min" v-model="dataSamplingSelect"> {{labelDataSampling5min[actualLanguage]}}
                              </label>
                              <label class="radio-inline" for="example-inline-radio3">
                                  <input type="radio" value="Hour" v-model="dataSamplingSelect"> {{labelDataSamplingHour[actualLanguage]}}
                              </label>
                              <label class="radio-inline" for="example-inline-radio3">
                                  <input type="radio" value="Day" v-model="dataSamplingSelect"> {{labelDataSamplingDays[actualLanguage]}}
                              </label>
                          </div>
                      </div>
                    </div>


                      <div class="col-xs-12">
                        <button type="button" @click="refreshGraph()" class="btn btn-success" name="button"><spinner size="small" v-if="flagGraphDataIsLoading"></spinner>
                        <span v-else><i class="fa fa-repeat pull-left"></i>{{ labelButtonRefresh[actualLanguage] }}</span></button>
                      </div>
                  </div>

              </div>
          </div>



          <div class="col-sm-12">

            <div class="col-sm-12 col-md-4">
                <div class="block block-rounded">
                  <div class="block-content text-center"> 
                    <i class="fa fa-bolt fa-3x text-success"></i>
                    <p><span class="h5 text">{{ labelGraphPeakCurrent[actualLanguage] }}</span></p>
                    <p class="h4 font-w700">{{maxCurrent | round}} <span class="h4 text">A</span></p>
                  </div>
                </div>
            </div>



            <div class="col-sm-12 col-md-4">
                <div class="block block-rounded">
                  <div class="block-content text-center">
                    <i class="fa fa-money fa-3x text-success"></i>
                    <p v-if="actualBundle.channels[channelIndex].ChannelData.channelInfo.iconFile === 'SolarPanel.png'"><span class="h5 text-muted">{{ labelGraphSaving[actualLanguage] }}</span></p>
                    <p v-else><span class="h5 text-muted">{{ labelGraphCost[actualLanguage] }}</span></p>
                    <p class="h4 font-w700">{{sumCost | toCurrency }} <span class="h4 text-muted"></span></p>
                  </div>
                </div>
            </div>



            <div class="col-sm-12 col-md-4">
                <div class="block block-rounded">
                  <div class="block-content text-center">
                    <i class="fa fa-download fa-3x text-success"></i>
                    <p v-if="actualBundle.channels[channelIndex].ChannelData.channelInfo.iconFile === 'SolarPanel.png'"><span class="h5 text-muted">Production</span></p>
                    <p v-else><span class="h5 text-muted">{{ labelGraphConsumption[actualLanguage] }}</span></p>
                    <p class="h4 font-w700">{{sumKWH | round}} <span class="h4 text-muted">kWh</span></p>
                  </div>
                </div>
            </div>

          </div>






        <div v-if="flagDisplayHistogramSection" class="form-group" style="height:400px">
          <div class="col-sm-12 col-md-12">

            <div class="col-sm-12 col-md-6">
              <select @change="constructHistogramData" v-model="selectedDataType" class="js-select2">
                <option value="cost">{{ labelSelectorCost[actualLanguage] }}</option>
                <option value="kwh">{{ labelSelectorKWH[actualLanguage] }}</option>
                <option value="peakPower">{{ labelSelectorPeakPower[actualLanguage] }}</option>
                <option value="peakCurrent">{{ labelSelectorPeakCurrent[actualLanguage] }}</option>
              </select>
            </div>

            <div class="col-sm-12 col-md-6">
              <label class="css-input switch switch-success">{{labelHistogramTypeDay[actualLanguage]}}
                  <input @change="constructHistogramData" type="checkbox" checked v-model="flagDisplayHistogramHr"><span></span>{{labelHistogramTypeHr[actualLanguage]}}
              </label>
            </div>

            <div class="col-sm-12">
              <div v-if="flagDisplayHistogramHr">
                <div class="block-content block-content-full bg-gray-lighter text-center">
                  <!-- <monthly-fee-chart :charges="charges"></monthly-fee-chart> -->
                  <bar-chart  :chartData="histogramData" ></bar-chart>
                </div>

                <div v-if="flagHistogramDataComputed" class="col-xs-12 col-sm-12 align-center">
                  <download-csv class = "btn btn-default" :data = "histogramDataDownloadHour" name = "ChannelHistogramHrData.csv"><i class="fa fa-download fa-1x push-5-r "></i>{{labelButtonDownloadData[actualLanguage]}}</download-csv>
                </div>

              </div>
              <div v-else>
                <div class="block-content block-content-full bg-gray-lighter text-center">
                  <!-- <monthly-fee-chart :charges="charges"></monthly-fee-chart> -->
                  <bar-chart  :chartData="histogramDataDay" ></bar-chart>
                </div>

                <div v-if="flagHistogramDataComputed" class="col-xs-12 col-sm-12 align-center">
                  <download-csv class = "btn btn-default" :data = "histogramDataDownloadDay" name = "ChannelHistogramDayData.csv"><i class="fa fa-download fa-1x push-5-r "></i>{{labelButtonDownloadData[actualLanguage]}}</download-csv>
                </div>

              </div>


            </div>
          </div>
        </div>

  </div>

</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters} from 'vuex'
import BarChart from '@/components/BarChart.js'
import { DatePicker, TimePicker, TimeSelect } from 'element-ui';
import Spinner from '../../../components/Spinner.vue'

import Vue from 'vue'
import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)

//https://apexcharts.com/docs/vue-charts/
import VueApexCharts from 'vue-apexcharts'
//Next line are executed in PortGraph!!!
//Vue.use(VueApexCharts)
//Vue.component('apexchart', VueApexCharts)


export default {
  props: ['channelIndex'],
  data() {
    return {
      timeRange : 0,
      readings : [],

      tableTitle : '',
      flagDisplayHistogramSection : false,
      flagDisplayHistogramHr : true,
      flagHistogramDataComputed : false,
      histogramData : null,
      histogramDataDay : null,
      selectedDataType: 'cost',
      histogramDataDownloadHour : [],
      histogramDataDownloadDay:[],
      labelSelectorPeakCurrent: {FR: 'Appelde courant (A)', EN: 'Peak current (A)'},
      labelSelectorPeakPower: {FR: 'Appel de puissance (W)', EN: 'Peak power (W)'},
      labelSelectorKWH: {FR: 'Consommation (kWh)', EN: 'Consumption (kWh)'},
      labelSelectorCost: {FR: 'Coût ($)', EN: 'Cost ($)'},

      labelHistogramTypeHr: {FR: 'Heure', EN: 'Hour'}, 
      labelHistogramTypeDay: {FR: 'Jour', EN: 'Day'}, 
      labelHistogramActivate: {FR: 'Activer', EN: 'Activate'}, 
      //labelHistogramPerHour: {FR: 'Histogramme par heure', EN: 'Hour histogram'}, 
      //labelHistogramPerDay: {FR: 'Histogramme par jour', EN: 'Daily histogram'},
      labelHistogramDay : {FR : ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'], EN: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']},
      labelButtonDownloadData: {FR: 'Télécharger les données', EN: 'Download data'},

      actualLanguage : "FR",

      //---------------------------------------------------------------
      //Variables for the date range picker
      //---------------------------------------------------------------
      cumulativeSumKWH : [],
      cumulativeSumCost : [],
      maxCurrent:0,
      sumCost:0,
      sumKWH:0,
      flagGraphDataIsLoading : false,
      labelGraphPeakCurrent: {FR: 'Courant maximum', EN: 'Max current'},
      labelGraphCost: {FR: 'Coût', EN: 'Cost'},
      labelGraphSaving: {FR: 'Économies', EN: 'Savings'},
      labelGraphConsumption: {FR: 'Consommation', EN: 'Consumption'},
      myStartDate: '',
      myEndDate: '',
      startTime: '00:00',
      endTime: '00:00',
      dataSamplingSelect : 'Automatic',
      myStartDateTime : this.startDate,
      myEndDateTime : this.endDate,
      labelStartDate: {FR: 'Date de début', EN: 'Start date'},
      labelStartTime: {FR: 'Heure de début', EN: 'Start time'},
      labelEndDate: {FR: 'Date de fin', EN: 'End date'},
      labelEndTime: {FR: 'Heure de fin', EN: 'End time'},
      labelButtonRefresh: {FR: 'Rafraichir le graphique', EN: 'Refresh graph'},
      labelDataSamplingTitle: {FR: 'Type de données :', EN: 'Data type :'},
      labelDataSamplingAuto: {FR: 'Automatique', EN: 'Automatic'},
      labelDataSampling5min: {FR: '5 minutes', EN: '5 minute'},
      labelDataSamplingHour: {FR: 'Heure', EN: 'Hour'},
      labelDataSamplingDays: {FR: 'Jour', EN: 'Days'},
      //---------------------------------------------------------------



    }
  },

  components: {
    BarChart,
    DatePicker,
    TimePicker,
    TimeSelect,
    Spinner
  },

  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
    ...mapState('chargesStore',['startDate', 'endDate']),
  },

  methods: {


   constructHistogramData(){

     let costHr = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
     let kwhHr = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
     let peakPowerHr = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
     let peakCurrentHr = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]

     let costDay = [0,0,0,0,0,0,0]
     let kwhDay = [0,0,0,0,0,0,0]
     let peakPowerDay = [0,0,0,0,0,0,0]
     let peakCurrentDay = [0,0,0,0,0,0,0]

      for (let j = 0; j < this.readings.length;j++){
          var str = this.readings[j].timestamp
          var dayOfWeek = new Date(str).getDay();
          //console.log(str)
          //console.log(dayOfWeek)
          costHr[parseInt(str.substr(12,2))] = costHr[parseInt(str.substr(12,2))] + this.readings[j].cost
          costDay[dayOfWeek] = costDay[dayOfWeek] + this.readings[j].cost

          kwhHr[parseInt(str.substr(12,2))] = kwhHr[parseInt(str.substr(12,2))] + this.readings[j].kwr
          kwhDay[dayOfWeek] = kwhDay[dayOfWeek] + this.readings[j].kwr

          if(this.readings[j].peak > peakPowerHr[parseInt(str.substr(12,2))]){peakPowerHr[parseInt(str.substr(12,2))]=this.readings[j].peak}
          if(this.readings[j].peak > peakPowerDay[dayOfWeek]){peakPowerDay[dayOfWeek]=this.readings[j].peak}

          if(this.readings[j].peakCurrent > peakCurrentHr[parseInt(str.substr(12,2))]){peakCurrentHr[parseInt(str.substr(12,2))]=this.readings[j].peakCurrent}
          if(this.readings[j].peakCurrent > peakCurrentDay[dayOfWeek]){peakCurrentDay[dayOfWeek]=this.readings[j].peakCurrent}
      }

      let dataHr = costHr
      let dataDay = costDay

      if(this.selectedDataType=="kwh"){
        dataHr = kwhHr
        dataDay = kwhDay
      }

      if(this.selectedDataType=="peakPower"){
        dataHr = peakPowerHr
        dataDay = peakPowerDay
      }

      if(this.selectedDataType=="peakCurrent"){
        dataHr = peakCurrentHr
        dataDay = peakCurrentDay
      }


      //Compute Histogram data
      this.histogramData = {
      labels: ['0:00','1:00','2:00','3:00','4:00','5:00','6:00','7:00','8:00','9:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
      datasets: [{
        // bezierCurve: false,
        label: '',
        backgroundColor: 'rgba(70, 195, 123, 0.8)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: dataHr }]
      }


      //Compute Histogram data Days
      this.histogramDataDay = {
      labels: this.labelHistogramDay[this.actualLanguage],
      datasets: [{
        // bezierCurve: false,
        label: '',
        backgroundColor: 'rgba(70, 195, 123, 0.8)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: dataDay }]
      }

      this.histogramDataDownloadHour = []
      this.histogramDataDownloadDay = []

      for (let j = 0; j < dataHr.length;j++){
          this.histogramDataDownloadHour.push({'Hour':this.histogramData.labels[j],'Cost':costHr[j],'kWh':kwhHr[j],'Peak Power':peakPowerHr[j],'Peak Current':peakCurrentHr[j]})
      }

      for (let j = 0; j < dataDay.length;j++){
          this.histogramDataDownloadDay.push({'Day':this.labelHistogramDay[this.actualLanguage][j],'Cost':costDay[j],'kWh':kwhDay[j],'Peak Power':peakPowerDay[j],'Peak Current':peakCurrentDay[j]})
      }

      this.flagHistogramDataComputed = true
    },


  refreshGraph(){
      this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime)
      this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime)
      this.flagGraphDataIsLoading = true
      var requestData = { 'postAction':'GetChannelReadings',
                          'bundleId':this.actualBundle.bundle_id,
                          'channelId':this.actualBundle.channels[this.channelIndex].ChannelData.channelId,
                          'start':this.myStartDateTime,
                          'end':this.myEndDateTime,
                          'dataSampling':this.dataSamplingSelect,
                          }
      //console.log(requestData)

      this.$store.dispatch('sessionStore/postChannel', requestData)
          .then((response) => {
          if(response.data.Code=='OK'){
              this.readings = response.data.ChannelReadings
              this.computeCumulativeSum()
              this.constructHistogramData()
              this.flagGraphDataIsLoading = false
              }
              else{ 
                window.alert(response.data.PromptMessage[this.actualLanguage])
                this.flagGraphDataIsLoading = false
                }
          }) 
          
        this.$store.dispatch('chargesStore/setStartDate', this.myStartDateTime)
        this.$store.dispatch('chargesStore/setEndDate', this.myEndDateTime)

      },

  computeCumulativeSum(){
    this.cumulativeSumKWH = _.map(this.readings, function(data){ return data.kwr; })
    var Sum = this.cumulativeSumKWH[0]
    for(var i = 1; i < this.cumulativeSumKWH.length;i++){
      Sum += this.cumulativeSumKWH[i]
      this.cumulativeSumKWH[i]=Sum.toFixed(3)
      this.cumulativeSumKWH[i]=Sum.toFixed(3)
    }
    this.sumKWH=Sum

    this.cumulativeSumCost = _.map(this.readings, function(data){ return data.cost; })
    var Sum = this.cumulativeSumCost[0]
    for(var i = 1; i < this.cumulativeSumCost.length;i++){
      Sum += this.cumulativeSumCost[i]
      this.cumulativeSumCost[i]=Sum.toFixed(3)
    }
    this.sumCost = Sum

    var currents = _.map(this.readings, function(data){ return data.peakCurrent; })
    this.maxCurrent = 0
    for(var i = 1; i < this.cumulativeSumCost.length;i++){
      if(currents[i]>this.maxCurrent){this.maxCurrent=currents[i]}
    }
  },


  formatTimeToUnix(date, time) {
      const unixTime = moment(date)
      .set('hour', time.split(':')[0])
      .set('minute', time.split(':')[1])
      .set('seconds', 0)
      .unix()
      return unixTime
    },



  },
  mounted() {
    this.timeRange = this.endDate - this.startDate
    this.readings = this.actualBundle.channels[this.channelIndex].ChannelData.Readings
    //console.log('----Histogram:READINGS-----')
    //console.log(this.actualBundle.channels[this.channelIndex].ChannelData.Readings)
    //console.log(this.readings)
    

    this.tableTitle='None'
        this.flagDisplayHistogramSection = true

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.myStartDate = new Date(this.startDate * 1000),
    this.myEndDate = new Date(this.endDate * 1000)

    var DateStringSplit = this.myStartDate.toString().split(':')
    this.startTime = DateStringSplit[0].substring(DateStringSplit[0].length-2,DateStringSplit[0].length)+':'+DateStringSplit[1]

    DateStringSplit = this.myEndDate.toString().split(':')
    this.endTime = DateStringSplit[0].substring(DateStringSplit[0].length-2,DateStringSplit[0].length)+':'+DateStringSplit[1]
    

    this.myStartDateTime = this.formatTimeToUnix(this.myStartDate, this.startTime)
    this.myEndDateTime = this.formatTimeToUnix(this.myEndDate, this.endTime)

    this.computeCumulativeSum()
    this.constructHistogramData()


  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// HistogramGraph.vue?3021a1c8